import clsx from "clsx";
import { useLogoUrl } from "./useLogoUrl";
import Hum from "@/ui/atoms/Icon/Hum";

interface DynamicLogoProps {
    className?: string;
    fallbackClassName?: string;
    alt?: string;
}

export function DynamicLogo({
    className = "sm:mb-6 h-[68px] w-[66px] rounded-lg",
    fallbackClassName = "mb-3 h-[68px] w-[66px] rounded-lg ",
    alt = "Logo",
}: DynamicLogoProps) {
    const { logoUrl, isLoading } = useLogoUrl();

    if (isLoading) {
        return (
            <div
                className={clsx(fallbackClassName, "animate-pulse bg-gray-200")}
            />
        );
    }

    if (logoUrl) {
        return <img src={logoUrl} alt={alt} className={className} />;
    }

    return <Hum className={fallbackClassName} width="40" height="40" />;
}
